import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShortenTextPipe } from './shorten-text.pipe';



@NgModule({
    declarations: [ShortenTextPipe],
    exports: [ShortenTextPipe],
    imports: [
        CommonModule
    ]
})
export class ShortenTextModule { }
